module.exports = __webpack_public_path__ + "static/img/gpt66.6e7162d9.png";